import React, {useState} from 'react';
import _ from 'lodash';

export default function useValidationErrors() {
    const [errors, setErrors] = useState({});

    const setError = (key, value) => {
        setErrors(prevErrors => {
            prevErrors[key] = value;

            return {...prevErrors};
        });
    };

    const clearError = key => {
        setErrors(prevErrors => _.omit(prevErrors, key));
    };

    const clearAllErrors = () => {
        setErrors({});
    };

    return {
        errors,
        setError,
        clearError,
        clearAllErrors
    };
}